const results = {
    links: {
        participants: 'Виж участниците',
    },
    title: 'Резултати {{year}}',
    loading: 'Зареждане...',
    errors: {
        unavailableForYear: 'Няма налични резултати за {{year}} година.',
        loadFailed: 'Все още няма налични резултати. Моля, опитайте отново по-късно.',
    },
    table: {
        position: 'Позиция',
        name: 'Име',
        bib: 'Стартов номер',
        result: 'Резултат',
        dnf: 'DNF',
        distance: 'Дистанция',
        category: 'Категория',
        team: 'Отбор',
        finish: 'Финал',
    },
    sections: {
        distanceTitle: '{{title}} - {{distance}} км',
        overallCurrent: 'Общо класиране',
        men: 'Мъже',
        womenCurrent: 'Жени',
        menUnder20: 'Мъже до 20',
        womenUnder20: 'Жени до 20',
        menOver40: 'Мъже над 40',
        womenOver40: 'Жени над 40',
        noRecordedResults: 'Участници без отчетен резултат',
        overall: 'Общо класиране {{distance}} км',
        women: 'Класиране - категория Жени / {{distance}} км',
        women40: 'Класиране - категория Жени 40+ / {{distance}} км',
        men40: 'Класиране - категория Мъже 40+ / {{distance}} км',
        men20: 'Класиране - категория Мъже до 20 / {{distance}} км',
        women20: 'Класиране - категория Жени до 20 / {{distance}} км',
    },
};

export default results;
